'use strict';

import ApiEndpoint from './api_endpoint';

export default class UpdateMyPerson extends ApiEndpoint {
  execute(callback = undefined, session = undefined, params = undefined) {
    if (session === undefined) {
      return this.session.put('/person', params, callback);
    }
    return session.put('/person', params, callback);
  }
}
